import { TextLink } from '@/modules/Frontend/UiBlocks'

import { Badge } from '../../../../Theme'

interface OutOfStockMessageProps {
  showAddToCart: boolean
  hasCategory: boolean
}

export function OutOfStockMessage({ showAddToCart, hasCategory }: OutOfStockMessageProps) {
  if (hasCategory) {
    return (
      <div className="bg-cards-bg w-full p-2 text-center">
        <Badge variant="outOfStock" className="text-lg xl:text-2xl px-4 py-1 font-montserrat">
          Produsul nu mai este disponibil
        </Badge>
      </div>
    )
  }

  return (
    <div className="flex justify-center flex-col w-full">
      <div className="bg-cards-bg w-full p-2 text-center">
        <Badge variant="outOfStock" className="text-lg xl:text-2xl px-4 py-1 font-montserrat">
          {!showAddToCart ? 'Produsul nu se mai comercializeaza' : 'STOC EPUIZAT'}
        </Badge>
      </div>
      {showAddToCart && (
        <p className="bg-cards-bg w-full h-auto text-center text-custom-red text-lg">
          Acest produs este indisponibil în stocurile noastre. Pentru a verifica disponibilitatea la producător, te rugăm să ne{' '}
          <TextLink
            variant="underline"
            href="https://www.tools.store.ro/contact"
            title="Contactează-ne"
            className="font-bold text-custom-red hover:text-custom-red"
          >
            contactezi
          </TextLink>
        </p>
      )}
    </div>
  )
}
